import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import TopoEmpresa from "../../../../components/TopoEmpresa";
import Topo from "../../../../components/Topo";
import Footer from "../../../../components/Footer";
import DuvidasEditarSection from "./DuvidasEditarSection";
import { isAuthenticatedNode, getUserNode } from "../../../../services/auth_node";

class TicketEditar extends Component {
  constructor(props) {
    super(props);
    this.state = {
      allowed: false,
      load: true,
      loading: false,
      faixa_minimizada: false,
      id_duvida: this.props.match.params.id,
      id_resposta: this.props.match.params.idResposta
    };
  }

  async componentWillMount() {
    if (!isAuthenticatedNode()) {
      window.location.href = "/";
    }
  }
  render() {
    return (
      <div>
        {getUserNode().alunoEmpresa &&
          getUserNode().empresa &&
          getUserNode().empresa.id !== 10705 ? (
          <TopoEmpresa />
        ) : (
          <Topo id_duvida={this.state.id_duvida} />
        )}
        <div>
          <DuvidasEditarSection idResposta={this.state.id_resposta} />
        </div>
        <Footer />
      </div>
    );
  }
}

const mapStateToProps = (store) => ({ view_by_tab: store.home.aba });
export default connect(mapStateToProps)(withRouter(TicketEditar));
